const BoxesSerial = [];
const boxesSerial = (state = BoxesSerial, action) => {
  switch (action.type) {
    case 'EPIK_BOXES_SERIAL_CLEAR':
      return BoxesSerial;
    case 'EPIK_BOXES_SERIAL_SUCCESS':
      return action.boxesSerial;
    default:
      return state;
  }
};

export default boxesSerial;
